import "./styles.scss";
import profile_photo from "../../assets/profile_photo.jpg";
import {BiFace} from "react-icons/bi";
import {RiArticleLine, RiContactsBookFill} from "react-icons/ri";
import {MdWork} from "react-icons/md";
import {BsCalendarEvent} from "react-icons/bs";
import {RxCounterClockwiseClock, RxHamburgerMenu} from "react-icons/rx";
import {IoClose} from "react-icons/io5";
import {useState} from "react";
import researchgatelogo from "../../assets/research_gate.png";
import arxivlogo from "../../assets/arxivlogo.svg";
import googlescholar from "../../assets/googlescholar.png";
import logicGroup from "../../assets/logic_group.png";

const NavBar = () => {
  //const {t, i18n} = useTranslation();
  //const [language, setLanguage] = useState(i18n.language);
    const [openNav, setOpenNav] = useState(false);


  // const changeLanguage = useCallback((lang) => {
  //   i18n.changeLanguage(lang).then(() => {
  //     localStorage.setItem('i18nextLng', lang);
  //     setLanguage(lang);
  //   });
  // }, [i18n]);
  //
  // const langs = useMemo(() => {
  //   return ["en", "pt"].map((lang) => {
  //       return (
  //         <>
  //           <p className={"lang" + (lang === language ? " active" : "")} key={lang} onClick={() => changeLanguage(lang)}>{lang.toUpperCase()}</p>
  //           {lang !== "pt" && <p className={"lang_separator"} key={"langs_separator"}>|</p>}
  //         </>
  //       )
  //   })
  // }, [changeLanguage, language]);

    const isActive = (section) => {
        return false;
        //return window.location.hash === `#${section}`;
    }



    const sectionIcon = {
        "about": <BiFace />,
        "experience": <MdWork />,
        "articles": <RiArticleLine />,
        "recent": <RxCounterClockwiseClock />,
        "events": <BsCalendarEvent />,
        "links": <RiContactsBookFill />
    }

  return (
    <div className={"NavBar" + (openNav ? " open" : "")}>
        <div className={"profile_wrapper"}>
            <div className={"profile_image"}>
                <div style={{backgroundImage: `url(${profile_photo})`}}/>
            </div>
            <div className={"name"}>Pedro Pinto</div>
        </div>
        <div className={"menu"} onClick={() => setOpenNav(!openNav)}>{openNav ? <IoClose /> : <RxHamburgerMenu/>}</div>

        
    </div>)
}


export default NavBar;